import { useQuery } from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"

import { BffApiClientMolecule } from "@/app/api-client/store"
import { CollectionSortEnum } from "@anaconda/core/nft-collection/types"
import type { PriceValue } from "@anaconda/core/price/types"
import { CollectionSearchBlockchainMoleculeReatom } from "./collection-search-blockchain-molecule.reatom"

interface TrendingCollection {
  name: string
  image?: string
  id: string
  /** Absent when the collection has no floor on Rarible or Magic Eden. */
  floorPrice?: PriceValue
  /** The golden tick. */
  verified?: boolean
}

const TRENDING_COLLECTIONS_SIZE = 8

export const useTrendingCollectionsReatom = () => {
  const bffApiClient = useMolecule(BffApiClientMolecule)
  const { blockchainsQueryFilter } = useMolecule(
    CollectionSearchBlockchainMoleculeReatom,
  )
  // Call atom directly to get current value
  const blockchains = blockchainsQueryFilter()

  return useQuery({
    queryKey: ["trending-collections", blockchains],
    queryFn: async () => {
      const response = await bffApiClient.api.collections.search.$post({
        json: {
          text: "",
          size: TRENDING_COLLECTIONS_SIZE,
          blockchains,
          sort: CollectionSortEnum.VOLUME_DESC,
        },
      })

      if (!response.ok) {
        throw new Error("Failed to fetch trending collections")
      }

      const data = (await response.json()) as TrendingCollection[]
      // Ensure we only return the requested number of items
      return data.slice(0, TRENDING_COLLECTIONS_SIZE)
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchInterval: 5 * 60 * 1000, // Refetch every 5 minutes
  })
}
